"use client"

import { createContext, useContext, useLayoutEffect, useRef, useState, ReactNode } from "react"

export const FlightSearchPopoverMaxWidthContext = createContext<number | undefined>(undefined)

export function useFlightSearchPopoverMaxWidth() {
  return useContext(FlightSearchPopoverMaxWidthContext)
}

/** Measures width of the departure + destination block only and caps airport Popover width. */
export function FlightSearchPopoverBoundary({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null)
  const [maxW, setMaxW] = useState<number>()

  useLayoutEffect(() => {
    const el = ref.current
    if (!el) return
    const update = () => setMaxW(el.getBoundingClientRect().width)
    update()
    const ro = new ResizeObserver(update)
    ro.observe(el)
    return () => ro.disconnect()
  }, [])

  return (
    <FlightSearchPopoverMaxWidthContext.Provider value={maxW}>
      <div ref={ref} style={{ width: "100%" }}>
        {children}
      </div>
    </FlightSearchPopoverMaxWidthContext.Provider>
  )
}
